module.exports = __webpack_public_path__ + "static/media/rectangle-view-off.2356754c.svg";